import React from 'react';
import { useQuery } from '@apollo/client';
import { GET_ACTIVE_TEAMS } from '../../graphql/teams';
import { TEAM_DEPARTMENTS } from '../team-members/teams-constants';
import { getPropertyManagerDisplayName } from '../../utils/propertyManagers';

export default function PropertyManagementAssignment({
  users = [],
  teamId = '',
  managerId = '',
  onChange,
  selectClassName = '',
}) {
  const { data: teamsData } = useQuery(GET_ACTIVE_TEAMS, {
    variables: { department: TEAM_DEPARTMENTS.PROPERTY_MANAGEMENT },
  });
  const teams = teamsData?.activeTeams || [];
  const assignmentType = teamId ? 'team' : 'person';

  const handleTypeChange = (nextType) => {
    if (nextType === 'team') {
      onChange({ propertyManagementTeamId: teams[0]?.id ? String(teams[0].id) : '', propertyManagerId: '' });
      return;
    }
    onChange({ propertyManagementTeamId: '', propertyManagerId: '' });
  };

  return (
    <div className="space-y-2">
      <div className="flex gap-4 text-sm">
        <label className="inline-flex items-center gap-2">
          <input
            type="radio"
            name="property-management-type"
            checked={assignmentType === 'person'}
            onChange={() => handleTypeChange('person')}
          />
          One property manager
        </label>
        <label className="inline-flex items-center gap-2">
          <input
            type="radio"
            name="property-management-type"
            checked={assignmentType === 'team'}
            onChange={() => handleTypeChange('team')}
          />
          Property management team
        </label>
      </div>
      {assignmentType === 'team' ? (
        <select
          aria-label="Property management team"
          className={selectClassName}
          value={teamId}
          onChange={(event) => onChange({
            propertyManagementTeamId: event.target.value,
            propertyManagerId: '',
          })}
        >
          <option value="">Select a team</option>
          {teams.map((team) => (
            <option key={team.id} value={String(team.id)}>{team.name}</option>
          ))}
        </select>
      ) : (
        <select
          aria-label="Property manager"
          className={selectClassName}
          value={managerId}
          onChange={(event) => onChange({
            propertyManagementTeamId: '',
            propertyManagerId: event.target.value,
          })}
        >
          <option value="">Select a property manager</option>
          {users.map((user) => (
            <option key={user.id} value={String(user.id)}>
              {getPropertyManagerDisplayName(user)}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}

export function buildPropertyManagementInput(formData) {
  if (formData.propertyManagementTeamId) {
    return {
      propertyManagementTeamId: parseInt(formData.propertyManagementTeamId, 10),
      propertyManagerId: null,
      propertyManagerIds: [],
    };
  }
  const propertyManagerId = formData.propertyManagerId || null;
  return {
    propertyManagementTeamId: null,
    propertyManagerId,
    propertyManagerIds: propertyManagerId ? [propertyManagerId] : [],
  };
}

export function getPropertyManagementFormValues(property) {
  if (property?.propertyManagementTeamId) {
    return {
      propertyManagementTeamId: String(property.propertyManagementTeamId),
      propertyManagerId: '',
    };
  }
  return {
    propertyManagementTeamId: '',
    propertyManagerId: property?.propertyManagerId ? String(property.propertyManagerId) : '',
  };
}
